import config from '../../config';

export const pushNotificationsSelector = state => state.notifications.pushNotifications;
export const trpcNotificationsSelector = state => state.notifications.trpcNotifications;

export const notificationsSelector = state =>
  config.isBatchInboxEnabled && !__DEV__ ? pushNotificationsSelector(state) : trpcNotificationsSelector(state);
